import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { GetSeasonTypesInputDto, SeasonTypeCreateDto, SeasonTypeDto, SeasonTypeExcelDownloadDto, SeasonTypeUpdateDto } from '../dtos/season-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class SeasonTypeService {
  apiName = 'WoodSupply';
  

  create = (input: SeasonTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SeasonTypeDto>({
      method: 'POST',
      url: '/api/woodSupply/seasonTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/woodSupply/seasonTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/woodSupply/seasonTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SeasonTypeDto>({
      method: 'GET',
      url: `/api/woodSupply/seasonTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/woodSupply/seasonTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetSeasonTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<SeasonTypeDto>>({
      method: 'GET',
      url: '/api/woodSupply/seasonTypes',
      params: { name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: SeasonTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/woodSupply/seasonTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SeasonTypeDto[]>({
      method: 'GET',
      url: '/api/woodSupply/seasonTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: SeasonTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SeasonTypeDto>({
      method: 'PUT',
      url: `/api/woodSupply/seasonTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
